var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.4659,
    cy: 10.4659,
    r: 10.4659,
    fill: "#D22929"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.48728 16.4623C5.92023 16.8952 6.62218 16.8952 7.05513 16.4623L10.9746 12.5429L14.8943 16.4626C15.3272 16.8955 16.0292 16.8955 16.4621 16.4626C16.8951 16.0296 16.8951 15.3277 16.4621 14.8947L12.5424 10.975L16.4622 7.05521C16.8952 6.62226 16.8952 5.92031 16.4622 5.48736C16.0293 5.05441 15.3273 5.05441 14.8944 5.48736L10.9746 9.40717L7.05505 5.48765C6.6221 5.0547 5.92015 5.0547 5.4872 5.48765C5.05425 5.9206 5.05425 6.62255 5.4872 7.0555L9.40671 10.975L5.48728 14.8944C5.05433 15.3274 5.05433 16.0293 5.48728 16.4623Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportError);
export default __webpack_public_path__ + "static/media/ReportError.0fe7f073d7d2f5cf2dfa70c2af4ff194.svg";
export { ForwardRef as ReactComponent };